// extracted by mini-css-extract-plugin
export default {"cssBreakpointExpandedFilters":"1686px"};